module.exports = __webpack_public_path__ + "static/media/HeroSaladLine.8a2eb49e.jpg";